<template>
  <page :loading="!selectedUser">
    <!-- b-nav pills class="mb-3">
      <b-nav-item :to="{ name: 'Profile' }" active>Your Profile</b-nav-item>
      <b-nav-item :to="{ name: 'ProfileSessions' }">Your Sessions</b-nav-item>
      <b-nav-item :to="{ name: 'ProfileAlerts' }" v-if="$root.isBupaDental">Your Alerts</b-nav-item>
      <b-nav-item :to="{ name: 'ProfileSyncContacts' }" v-if="$root.canSyncContacts">Sync Contacts</b-nav-item>
    </b-nav -->
    <profile-show
      class="mt-3"
      :user="selectedUser"
      @openEditModal="openEditModal($event)"
      @openEditAccountModal="$bvModal.show('edit-account-modal')"
    />
    <b-modal id="edit-profile-modal" size="lg" title="Edit Profile" hide-footer>
      <profile-editor
        :fields="inputFields"
        :inputSelectionField="inputSelectionField"
        :value="inputValues"
        @input="updateProfile($event)"
        @cancel="$bvModal.hide('edit-profile-modal')"
      />
    </b-modal>
    <b-modal id="edit-account-modal" size="lg" title="Edit Account" hide-footer>
      <account-editor
        @cancel="$bvModal.hide('edit-account-modal')"
      />
    </b-modal>
  </page>
</template>

<script>
import { mapRoot } from '@src/mixins/root';
import Page from '@/components/Page';
import ProfileShow from '@/components/profile/ProfileShow';
import ProfileEditor from '@/components/profile/ProfileEditor';
import AccountEditor from '@/components/profile/AccountEditor';
import UserProfileQuery from '@/graphql/queries/UserProfile.gql';
import gql from 'graphql-tag';

const WriteUserQuestionsMutation = gql`
  mutation WriteUserCustomFields($update: [ UpdateUserCustomFieldInput! ]!) {
    updateManyUserCustomFields(update: $update) {
      key
      value
    }
  }
`;

const UpdateUserResumeMutation = gql`
  mutation UpdateUserResume($userID: ID, $resumeID: ID) {
    updateUser(where: { id: $userID }, update: { resume: { id: $resumeID } }) {
      id
    }
  }
`;

const AddTaxonomySkillSuggestionsMutation = gql`
  mutation AddTaxonomySkillsSuggestions($skills: [String!]) {
    createTaxonomySkillSuggestions(skills: $skills)
  }
`;

export default {
  components: {
    Page,
    ProfileShow,
    ProfileEditor,
    AccountEditor,
  },
  metaInfo: {
    title: 'Your Profile',
  },
  data: () => ({
    inputFields: [],
    inputSelectionField: null,
    inputValues: {},
  }),
  watch: {
    selectedUser() {
      console.log('SELECTED USER: ', this.selectedUser);
    }
  },
  apollo: {
    selectedUser: {
      query: UserProfileQuery,
      update: ({ user }) => user,
      error(err) {
        this.$notifyFatalErr(err);
      },
      fetchPolicy: 'network-only',
    },
  },
  computed: {
    ...mapRoot([ 'user', 'company' ]),
    userID() {
      if (this.user && this.user.id) {
        return this.user.id;
      } else {
        return null;
      }
    },
  },
  methods: {
    openEditModal({ name, fields, values }) {
      console.log('FIELDS AND VALUES: ', { name, fields, values });
      this.inputFields = fields;
      this.inputValues = values;
      if (name === 'jobs') {
        this.inputSelectionField = 'EMPLOYEE-JOB-SELECTIONS';
      } else {
        this.inputSelectionField = null;
      }
      this.$bvModal.show('edit-profile-modal');
    },
    async updateProfile({ inputValues: values, skillSuggestions }) {
      try {
        this.inputValues = values;
        const { inputValues } = this;

        if (Object.keys(inputValues).length) {
          const { userID } = this;
          await this.$apollo.mutate({
            mutation: WriteUserQuestionsMutation,
            variables: {
              update: Object.keys(inputValues).map(key => ({
                key,
                value: typeof inputValues[key] === 'string' ? inputValues[key] : (inputValues[key] ? JSON.stringify(inputValues[key]) : null),
              })).filter(({ value }) => value),
            },
            update(store, { data: { updateManyUserCustomFields: fields } }) {
              const data = store.readQuery({ query: UserProfileQuery, variables: { userID } });
              data.user.customFields = data.user.customFields.map(field => {
                if (inputValues[field.key]) {
                  field.value = inputValues[field.key];
                }
                return field;
              });
              store.writeQuery({ query: UserProfileQuery, data });
            },
          });

          // update resume field if defined
          const { customFields } = this.company || {};
          const resumeField = Array.isArray(customFields) ? customFields.find(el => el && el.type === 'CV_UPLOAD') : [];
          const resumeKey = resumeField ? resumeField.key : null;
          const resume = resumeKey ? inputValues[resumeKey] : null;
          if (resume && resume.id) {
            await this.$apollo.mutate({
              mutation: UpdateUserResumeMutation,
              variables: { userID: this.user.id, resumeID: resume.id },
            });
          }
        }

        if (!this.$root.isCXR) {
          const suggestedSkills = skillSuggestions['JOB_SKILLS'].concat(
            skillSuggestions['JOB_DEVELOPMENT_SKILLS'].filter(item => skillSuggestions['JOB_SKILLS'].indexOf(item) < 0)
          ).filter(el => el);
          if (Array.isArray(suggestedSkills) && suggestedSkills.length) {
            await this.$apollo.mutate({
              mutation: AddTaxonomySkillSuggestionsMutation,
              variables: { skills: suggestedSkills }
            });
          }
        }

        this.$bvModal.hide('edit-profile-modal');
      } catch (err) {
        console.error(err);
      }
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/views/User/Profile.vue